import {z} from "zod";
import {difyChatChunkRetrieverResource, difyChatChunkSchema} from "./dify-chat-language-model";
import {getFilePreviewLink} from "../../apis/file-store";

export async function generateMarkdown(citation: z.infer<typeof difyChatChunkSchema>): Promise<string> {
    // contain pdf at the beginning
    let output: string = `
    
---

> 參考連結: 
`
    const retriever_resources = citation.metadata?.retriever_resources
    if (retriever_resources === undefined) {
        return ""
    }
    if (retriever_resources.length === 0) {
        return ""
    }
    // citation.metadata?.retriever_resources?.forEach((resource ,i)=> {
    for (let i = 0; i < retriever_resources.length; i++) {
        const resource = retriever_resources[i]
        // const splitName = resource.dataset_name?.split(/-/,2);
        const input = resource.dataset_name
        const index = input?.indexOf('-');
        if (index === undefined) {
            continue
        }
        if (index === -1) {
            continue
        }

        const splitName = [input?.substring(0, index), input?.substring(index + 1)];
        console.log('splitName', splitName)
        const [type] = splitName
        switch (type) {
            case "pdf":
                try {
                    output += await generatePdf(resource, `ref-${i + 1}`)
                } catch (e) {
                    console.log(e)
                }
                break
            case "docs":
                output += generateDocs(resource, `ref-${i + 1}`)
                break
        }
    }
    return output
}

async function generatePdf(resource: z.infer<typeof difyChatChunkRetrieverResource>, linkText: string): Promise<string> {
    const {document_name} = resource
    const input = resource.dataset_name
    const index = input?.indexOf('-');
    if (index === undefined) {
        return ""
    }
    if (index === -1) {
        return ""
    }

    const splitName = [input?.substring(0, index), input?.substring(index + 1)];
    const resourceName = splitName[1]
    const pageNumber = document_name?.split(".")[0]
    const filePreviewLink = await getFilePreviewLink(resourceName as string);

    return `> [${linkText}](${filePreviewLink.url}#page=${pageNumber})
`
}

function generateDocs(resource: z.infer<typeof difyChatChunkRetrieverResource>, linkText: string): string {
    const {document_name} = resource
    const input = resource.dataset_name
    const index = input?.indexOf('-');
    if (index === undefined) {
        return ""
    }
    if (index === -1) {
        return ""
    }

    const fileName = document_name?.split(".")[0]
    return `> [${linkText}](https://doc.api.dotzero.tech/${fileName})
`
}